import React from "react";
import { Navigate } from "react-router-dom";
import useUser from "../../hooks/useUsers";
import { canAccessLaborFee } from "../../shared/utils/repairShopOption";
import { PATH } from "../constants/path";

interface LaborFeeRouteProps {
  children: React.ReactElement;
}

const LaborFeeRoute: React.FC<LaborFeeRouteProps> = ({ children }) => {
  const { getAdminInfo } = useUser();

  return canAccessLaborFee(getAdminInfo()) ? (
    children
  ) : (
    <Navigate to={PATH.RESERVATION} replace />
  );
};

export default LaborFeeRoute;
